import { DeliveryActionTypes } from '../actions';
import { DeliveryState } from '../initial.state';

export const DeliveryReducer = (state = new DeliveryState(), { type, payload }) => {
  switch (type) {
    case DeliveryActionTypes.GET_CURRENT_TABLE_INFO: {
      return {
        ...state,
        tableInfoList: payload,
      };
    }

    case DeliveryActionTypes.UPDATE_ADDRESS_DATA: {
      let updatedItemList = state.tableInfoList.filter(item => {
        return item?.address?.deliveryPackageId === payload?.deliveryPackageId;
      });
      let updatedItem = { ...updatedItemList[0] };
      updatedItem.address = { ...payload };
      let updatedInfoList = state.tableInfoList.map(item =>
        item.id !== updatedItem.id ? item : updatedItem
      );
      return {
        ...state,
        tableInfoList: updatedInfoList,
      };
    }

    case DeliveryActionTypes.PROCESS_ORDER: {
      let updatedItemList = state.tableInfoList.filter(item => {
        return item.id !== payload.id;
      });
      return {
        ...state,
        tableInfoList: [...updatedItemList],
      };
    }

    case DeliveryActionTypes.CANCEL_ORDER: {
      let updatedItemList = state.tableInfoList.filter(item => {
        return item.id !== payload.id;
      });
      return {
        ...state,
        tableInfoList: [...updatedItemList],
      };
    }

    case DeliveryActionTypes.UPDATE_ORDER_DATA: {
      let updatedItemList = state.tableInfoList.filter(item => {
        return item.id === payload.id;
      });
      let updatedItem = { ...updatedItemList[0] };
      updatedItem = { ...payload };
      let updatedInfoList = state.tableInfoList.map(item =>
        item.id !== updatedItem.id ? item : updatedItem
      );
      return {
        ...state,
        tableInfoList: updatedInfoList,
      };
    }

    case DeliveryActionTypes.GET_ALL_CATALOGUES_DELIVERY_DATA: {
      return {
        ...state,
        catalogues: payload,
      };
    }

    default: {
      return state;
    }
  }
};
